import React, { useEffect, useState, useRef } from 'react'
import {
  Lead360CommonHeader,
  CommonHeaderMenuLinks,
  CommonHeaderProps,
} from '@acko-tech/building-blocks.ui.lead360-common-header'

interface Lead360CommonHeaderProps {
  isDisplay: boolean
}

const Header: React.FC<Lead360CommonHeaderProps> = ({ isDisplay }) => {
  const [headerProps, setHeaderProps] = useState<CommonHeaderProps>({ navigationLinks: [], logoURL: '' })
  const navigation = useRef<Array<CommonHeaderMenuLinks>>([])

  useEffect(() => {
    const Acko_URL = `${process.env.NEXT_PUBLIC_SITE_URL}`
    const CX_360_URL = `${process.env.NEXT_PUBLIC_CX_360}`
    const Lead_360_URL = `${process.env.NEXT_PUBLIC_LEAD360_LSIFRAME}`
    const Decision_Tree_URL = `${process.env.NEXT_PUBLIC_DECISION_TREE}`
    const CX_Communication_URL = `${CX_360_URL}/discover/communication_history`

    navigation.current = [
      {
        url: Lead_360_URL,
        name: 'Lsi frame',
      },
      {
        url: CX_360_URL,
        name: 'Customer 360',
      },
      {
        url: CX_Communication_URL,
        name: 'Communication History',
      },
      {
        url: Decision_Tree_URL,
        name: 'Decision Tree',
        isActive: true,
        navigationTargetValue: '_blank',
      },
      {
        url: `${Acko_URL}/masters2/payment`,
        name: 'Payment master',
        navigationTargetValue: '_blank',
      },
      {
        url: `${Acko_URL}/mastersearch/?master=customer&view=app`,
        name: 'Master policy',
        navigationTargetValue: '_blank',
      },
      {
        url: `${Acko_URL}/firefly-ui/#/admin/pi`,
        name: 'Pre inspection',
        navigationTargetValue: '_blank',
      },
      {
        url: `${Acko_URL}/firefly-ui/#/claims`,
        name: 'Claims',
        navigationTargetValue: '_blank',
      },
    ]

    setHeaderProps({ ...headerProps, ['navigationLinks']: navigation.current })
  }, [])

  return isDisplay && headerProps.navigationLinks && headerProps.navigationLinks.length > 0 ? (
    <>
      <div style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
        <Lead360CommonHeader {...headerProps} />
      </div>
    </>
  ) : (
    <></>
  )
}
export default Header
